import { createRequest, platform, SortOrder } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { InsightsPeriodNumber, PeriodVehicle, PeriodVehicleSortKeys } from "./types"
import { fromPeriodVehicleApi } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

type Input = Readonly<{
  limit?: number
  minimumDistanceDriven?: number
  periodNumber: InsightsPeriodNumber
  policyId: string
  sortKey?: PeriodVehicleSortKeys
  sortOrder?: SortOrder
}>
type Output = ReadonlyArray<PeriodVehicle>

const listPeriodVehicles = createRequest<Input, Output>(async (input: Input, getToken): Promise<Output> => {
  const useNewPipeline = isNewPipelinePolicy(input.policyId)
  const result = await platform(getToken).periods.getPeriodVehicles({
    ...input,
    ...(useNewPipeline ? { dbName: `athena` } : {}),
  })
  return fromPeriodVehicleApi(result)
})

export const useListPeriodVehicles = createRequestHook<Input, Output>(listPeriodVehicles)
